import servicetTableroIndicador from '@/services/GsEncuesta/tableroIndicador'

export default {
  TABLERO_INDICADOR_ENCUESTADOR_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      servicetTableroIndicador.findEncuestador(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  TABLERO_INDICADOR_REPORT_ALL(_, params) {
    return new Promise((resolve, reject) => {
      servicetTableroIndicador.findReportAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  TABLERO_INDICADOR_LINEA_TIEMPO(_, params) {
    return new Promise((resolve, reject) => {
      servicetTableroIndicador.findReportLineaTiempo(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  TABLERO_INDICADOR_PREGUNTA_RESPUESTA(_, params) {
    return new Promise((resolve, reject) => {
      servicetTableroIndicador.findReportPreguntaRespuesta(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  TABLERO_INDICADOR_CONSOLIDADO_FICHA(_, params) {
    return servicetTableroIndicador.printConsolidadoFicha(params)
  },
  TABLERO_INDICADOR_CONSOLIDADO_FICHA_2(_, params) {
    return servicetTableroIndicador.printConsolidadoFicha2(params)
  },
  TABLERO_INDICADOR_CONSOLIDADO_FICHA_PDF(_, params) {
    return servicetTableroIndicador.printConsolidadoFichaPdf(params)
  },
  TABLERO_INDICADOR_FICHA_PDF(_, params) {
    return servicetTableroIndicador.printFichaPdf(params)
  },
}
